import { FC, ReactNode, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFlagsmith } from 'flagsmith/react'
import { FEATURE_FLAGS } from '../utils'
interface IProps {
  children?: ReactNode
  userData: any
}

export const FeatureFlagGuard: FC<IProps> = ({ children, userData }) => {
  const [enable, setEnable] = useState<null | boolean>(null)
  const flagsmith = useFlagsmith()
  const navigate = useNavigate()

  const { signInUserSession } = userData
  const userId = signInUserSession?.idToken?.payload?.['custom:MemberMlsId']

  const identifyUser = async () => {
    await flagsmith.identify(`member:${userId}`)
    const isEnable = flagsmith.hasFeature(FEATURE_FLAGS.SHOWING_CHOICE)

    if (isEnable === false) {
      navigate('/denied')
      return
    }

    setEnable(isEnable)
  }

  useEffect(() => {
    identifyUser()
  }, [])

  if (enable === null) {
    return <></>
  }

  if (enable) {
    return children
  }
}
